import { cx } from '../utils/cx.js';
import styles from './Breadcrumbs.module.css';

export type BreadcrumbItem = { label: string; href?: string };

export type BreadcrumbsProps = {
  items: BreadcrumbItem[];
  className?: string;
  /** Single-line trail with ellipsis overflow (narrow headers). */
  layout?: 'wrap' | 'singleLine';
};

export function Breadcrumbs({ items, className, layout = 'wrap' }: BreadcrumbsProps) {
  return (
    <nav className={cx(styles.nav, className)} aria-label="Fil d'Ariane">
      <ol className={cx(styles.list, layout === 'singleLine' && styles.listSingleLine)}>
        {items.map((item, i) => (
          <li key={`${item.label}-${i}`} className={styles.item}>
            {i > 0 ? <span className={styles.sep} aria-hidden>→</span> : null}
            {item.href && i < items.length - 1 ? (
              <a href={item.href} className={styles.link}>
                {item.label}
              </a>
            ) : (
              <span className={styles.current}>{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
